var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "store_blocks" },
    [
      _c("div", {
        staticClass: "selected_store",
        domProps: {
          innerHTML: _vm._s(
            _vm.getStoreInfoByStore(
              _vm.$AllDivisions[_vm.locality.division_id]?.stores[0]
                ?.object_id || null
            )
          ),
        },
      }),
      _vm._v(" "),
      _vm._l(
        _vm.$StoreRelations[
          _vm.$AllDivisions[_vm.locality.division_id]?.stores[0]?.object_id
        ] || [],
        function (storeId, index) {
          return [
            _vm.$AllDivisions[_vm.locality.division_id]
              ? _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.getStoreInfoByStore(
                        storeId,
                        index === 0
                          ? _vm.$AllDivisions[_vm.locality.division_id]
                              ?.stores[0]?.object_id
                          : _vm.$StoreRelations[
                              _vm.$AllDivisions[_vm.locality.division_id]
                                ?.stores[0]?.object_id
                            ][index - 1]
                      )
                    ),
                  },
                })
              : _vm._e(),
          ]
        }
      ),
      _vm._v(" "),
      _vm.inRunnersStores &&
      +_vm.locality.city_id === 1 &&
      Object.keys(_vm.inRunnersStores[3]).length
        ? _c(
            "div",
            { staticClass: "extra_store_div" },
            _vm._l(_vm.inRunnersStores[3], function (storeData, storeId) {
              return _c("p", [
                _vm._v(_vm._s(storeData.title) + ":\n      "),
                _c("strong", [_vm._v(_vm._s(storeData.qty))]),
              ])
            }),
            0
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }